import { Text } from "@chakra-ui/react";
import { isThirdLevelOrBelow } from "src/components/common/comments-area/comment/comment-utils";
import { TComment } from "src/components/common/comments-area/comment/comment.types";
import { scrollIntoView } from "src/utils/dom";

type TParentCommentPreviewProps = {
    comment: TComment;
    parentDeleted?: boolean;
    parentMessage?: string;
};

const PARENT_COMMENT_PREVIEW_TEST_ID = "parent-comment-preview";

export const ParentCommentPreview = ({ comment, parentDeleted, parentMessage }: TParentCommentPreviewProps) => {
    const isThirdLevel = isThirdLevelOrBelow(comment);

    if (!isThirdLevel || !parentMessage) {
        return null;
    }

    const scrollParentIntoView = () => {
        if (!parentDeleted && comment.parentCommentId) {
            const parentElement = document.getElementById(comment.parentCommentId);

            if (parentElement) {
                scrollIntoView(parentElement);
            }
        }
    };

    return (
        <Text
            onClick={scrollParentIntoView}
            mb="0.5"
            fontSize="sm"
            borderLeft="2px solid"
            color="gray.600"
            borderLeftColor="gray.200"
            wordBreak="break-word"
            pl="1"
            noOfLines={[2, 1]}
            cursor={parentDeleted ? undefined : "pointer"}
            data-test-id={PARENT_COMMENT_PREVIEW_TEST_ID}
        >
            {parentMessage}
        </Text>
    );
};
